import { render, staticRenderFns } from "./aboutYiXi.vue?vue&type=template&id=d07bb93e&scoped=true&"
import script from "./aboutYiXi.vue?vue&type=script&lang=js&"
export * from "./aboutYiXi.vue?vue&type=script&lang=js&"
import style0 from "./aboutYiXi.vue?vue&type=style&index=0&id=d07bb93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07bb93e",
  null
  
)

export default component.exports